module.exports = __webpack_public_path__ + "static/media/kigra.4644e8f0.jpg";